export const MINIMUM_CARDS_FOR_QUEUE = 1export const MINIMUM_CARDS_FOR_QUEUE = 1